import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const logoLinkWrapper = style({
  margin: `${space.s28}px 0 ${space.s40}px`,
  width: '100%',
  transition: 'padding 0.2s ease-in-out',

  ...responsiveStyle({
    mobile: {
      display: 'none',
    },
    tablet: {
      display: 'block',
      padding: `0px 13.5px`,
    },
    laptop: {
      display: 'block',
      padding: `0px ${space.s60}px`,
    },
  }),
});

export const logoWrapperCollapsed = style({
  selectors: {
    '&:is(&)': {
      padding: `0px 13.5px`,
    },
  },
});

export const headerLogoContent = style({
  gap: space.s16,
  display: 'flex',
  height: '31px',
  alignItems: 'center',
  width: '268px',

  ...responsiveStyle({
    mobile: {
      display: 'none',
    },
    tablet: {
      display: 'flex',
    },
  }),
});

export const logoCollapsed = style({
  justifyContent: 'center',
  width: '48px',
  paddingLeft: 0,
});

export const logo = style({
  color: themeVars.color.text.inverse,
  minHeight: '29px',
  minWidth: '107px',
});

export const logoCompact = style({
  color: themeVars.color.text.inverse,
});
